﻿import React, { useState, useEffect, useCallback, useRef } from 'react';

import { products } from '../../../BookingFlowPage/Scripts/Endpoints';
import controller from '../../../../../Resources/Scripts/_Shared/Controller';
import { myAimoParkConfirm } from '../../../_Shared/Scripts/MyAimoParkConfirm';
import ExpandableListItem from './ExpandableListItem'
import { parseDate } from '../../../../../Resources/Scripts/_Shared/parseDate';

const ListItem = ({ facilitySearchContext, setFacilitySearchContext, facility, distance, url, name, location, address, filteredNotes, notesForZones, uid, date }) => {
  const lang = {
    ...facilitySearchContext.localization.headings,
    ...facilitySearchContext.localization.inputs,
    ...facilitySearchContext.localization.products,
    ...facilitySearchContext.localization.filter,
    ...facilitySearchContext.episerver,
    ...facilitySearchContext.localization.messages,
  };
  const listItemClass = 'facilitysearchpage__listitem';
  const currectDistance = distance > 1 ? distance.toFixed(2) : Math.round(distance * 1000);
  const currectDistanceText = distance > 1 ? 'km' : 'm';
  const selectedLanguage = facilitySearchContext.episerver.selectedlanguage === 'no' ? 'nb' : facilitySearchContext.episerver.selectedlanguage === 'se' ? 'sv' : facilitySearchContext.episerver.selectedlanguage;
  const currentLocale = facilitySearchContext.country === 'no' ? 'nb' : facilitySearchContext.country === 'se' ? 'sv' : facilitySearchContext.country;
  const listItemRef = useRef(null);
  const [pending, setPending] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [totalAvailability, setTotalAvailability] = useState(0);
  const [totalNonAvailability, setNonTotalAvailability] = useState(0);
  const [hasPromotion, setHasPromotion] = useState(null);
  const [hasAvailableSpot, setHasAvailableSpot] = useState(null);
  const [hasLowAvailability, setHasLowAvailability] = useState(null);
  const [isBookableOnline, setIsBookableOnline] = useState(null);
  const [servicesList, setServicesList] = useState('');
  const [lowestPriceProduct, setLowestPriceProduct] = useState(null);
  const [recommendedProduct, setRecommendedProduct] = useState(null);
  const facilityAddress = address.Number ? `${address.Street} ${address.Number}` : address.Street;
  const facilityName = name === facilityAddress ? facilityAddress : name;
  const [STP, setSTP] = useState(facilitySearchContext.filterSelection.STP);

  const [facilityInfo, setFacilityInfo] = useState({
    Address: facilityAddress,
    Preamble: facility.Preamble,
    LongTermOpeningHours: facility.LongTermOpeningHours,
    GiantLeapLink: facility.GiantLeapLink,
    DrivingInstructions: facility.DrivingInstructions,
    HasLTP: facility.HasLtp,
    HasSTP: facility.HasStp,
    FilteredNotes: filteredNotes,
  });
  let totalAvailabilityCount = 0;
  const advSearch = facilitySearchContext.advSearch;
  const showPriceSuggestionBox = facilitySearchContext.showPriceSuggestionBox;
  const showDarkerTheme = facilitySearchContext.showDarkerNewStyle;

  const expandHandler = (e) => {
    setExpanded(!expanded)
    e.preventDefault();
  };

  const [productSelectionOptions, setProductSelectionOptions] = useState([]);

  const availabilityChangeHandler = (productAvailability) => {
    totalAvailabilityCount++;

    const nonAvailabilityCount = listItemRef.current ? listItemRef.current.querySelectorAll('.book button[aria-busy="false"]:disabled').length : 0;
    setNonTotalAvailability(totalNonAvailability > nonAvailabilityCount ? totalNonAvailability : nonAvailabilityCount);

    if (totalAvailabilityCount >= productSelectionOptions.length)
      setAvailabilityLoading(false);
  }

  useEffect(() => {
    let isSubscribed = true;
    if (productSelectionOptions.length > 0) return;
    const getFacilitySummary = async () => {
      const stpSelected = facilitySearchContext.filterSelection.STP;
      const allProducts = await products.getProducts({ bookingController: facilitySearchContext.episerver.bookingController, fId: uid, lang: selectedLanguage, includeNotBookableOnline: true, availabilityFrom: date });
      if (allProducts.status === 200 && isSubscribed) {
        const listOfProducts = allProducts.body.Places.map(zone => zone.Item2).flat();
        const isBookable = listOfProducts.some(product => !product.OnlineBookingNotAllowed);
        const promotion = listOfProducts.some(product => Array.isArray(product.Promotions) && product.Promotions.length > 0);

        let productFilter = Object.keys(facilitySearchContext.filterSelection.ParkingSpaceTypeSelection).find(key => facilitySearchContext.filterSelection.ParkingSpaceTypeSelection[key])
        listOfProducts.forEach(product => {
          const matchingProduct = facility.ParkingZones.flatMap(zone => zone.Pmcs || []).find(pmc => pmc.PmcId === product.Id);
          product.ParkingSpaceType = matchingProduct ? matchingProduct.ParkingSpaceType : null;
        });
        
        const getRecommendedProducts = (products) => {
          let filteredProducts = (productFilter) ? products.filter(product => product.ParkingSpaceType === productFilter) : []; 

          if (filteredProducts.length === 0) filteredProducts = (promotion) ? products.filter(product => !product.OnlineBookingNotAllowed && product.Promotions) : [];

          if (filteredProducts.length === 0) filteredProducts = products.filter(product => product.Type === "NON_RESERVED" && !product.OverviewText.toLowerCase().includes("elbil") && product.ParkingSpaceType !== "Elbilsplats");

          if (filteredProducts.length === 0) filteredProducts = products;

          return filteredProducts;
        }

        if (advSearch && !stpSelected) {
          const availableProducts = listOfProducts.filter(product => product.MonthlyPrice && product.MonthlyPrice > 0); 

          let recommendedProducts = getRecommendedProducts(availableProducts);

          if (recommendedProducts.length === 0) recommendedProducts = getRecommendedProducts(listOfProducts);

          setRecommendedProduct(
            recommendedProducts.length > 0
              ? recommendedProducts.reduce((prev, current) => {
                  // If prev is null (the first iteration), set it to current
                  if (!prev) {
                    return current;
                  }
          
                  // Check if both products have Availability > 0
                  if ((prev.Availability && prev.Availability > 0) && (current.Availability && current.Availability > 0)) {
                    // If both have Availability > 0, compare MonthlyPrice
                    return current.MonthlyPrice && current.MonthlyPrice > prev.MonthlyPrice ? current : prev;
                  } else if (prev.Availability && prev.Availability > 0) {
                    // If only prev has Availability > 0, select prev
                    return prev.MonthlyPrice > 0 ? prev : current;
                  } else if (current.Availability && current.Availability > 0) {
                    // If only current has Availability > 0, select current
                    return current.MonthlyPrice > 0 ? current : prev;
                  } else {
                    // If neither has Availability > 0, return the one with a MonthlyPrice > 0
                    return prev.MonthlyPrice > current.MonthlyPrice ? prev : current;
                  }
                }, null)
              : null
          );
        }
       
        setIsBookableOnline(isBookable);
        setHasPromotion(promotion);
        setProductSelectionOptions(allProducts.body);
        setFacilityInfo({
          ...allProducts.body,
          ...facilityInfo
        })
        if (isBookable && !facilitySearchContext.episerver.hideAvailability) {
          setHasAvailableSpot(lang.availability && listOfProducts.some(product => !product.OnlineBookingNotAllowed && product.Availability && product.Availability > 0));
          setHasLowAvailability(lang.availability && !listOfProducts.some(product => !product.OnlineBookingNotAllowed && product.Availability && product.Availability > 4));
        }
      } else if (isSubscribed) {
        setFacilityInfo({
          ...facilityInfo,
          HasLTPBookableOnline: false,
          HasLTPNotBookableOnline: false
        });
        setLowestPriceProduct(false);
        setRecommendedProduct(false);
        setHasAvailableSpot(false);
        setHasLowAvailability(false);
        setHasPromotion(false);
      }
      if (isSubscribed) setPending(false);
    }
    setPending(true);
    getFacilitySummary();
    return () => isSubscribed = false;
  }, [date, facilitySearchContext.filterSelection.LTP, facilitySearchContext.filterSelection.ParkingSpaceTypeSelection])

  useEffect(() => {
    if (facilityInfo.HasWaitingList && facilityInfo.FilteredNotes && !pending) {
      controller.add('myaimopark-confirm', myAimoParkConfirm);
      controller.parse(listItemRef.current);
    }
    const facilitySearchPageWrapper = document.querySelector(".facilitysearchpage__wrapper");
    if (!pending && STP) facilitySearchPageWrapper.classList.add('STP');
    else if (!pending) facilitySearchPageWrapper.classList.remove('STP');
  }, [facilityInfo, pending])

  useEffect(() => {
    if (!facility) return;

    const services = [];
    if (facility.Indoor) services.push(lang.info.indoor.toLowerCase().replaceAll('&shy;', '\xAD'));
    if (!facility.Indoor) services.push(lang.info.outdoor.toLowerCase().replaceAll('&shy;', '\xAD'));
    if (facility.Info && facility.Info.Heated) services.push(lang.info.heated.toLowerCase().replaceAll('&shy;', '\xAD'));
    if (facility.Info && (facility.Info.MaxVehicleHeight && facility.Info.MaxVehicleHeight > 200)) services.push(lang.info.maxVehicleHeight.toLowerCase().replaceAll('&shy;', '\xAD'));
    if (facility.Services && facility.Services.includes('electricChargingPoint') && selectedLanguage === 'en') services.push(lang.services.electricchargingpoint.replaceAll('&shy;', '\xAD'));
    if (facility.Services && facility.Services.includes('electricChargingPoint') && selectedLanguage !== 'en') services.push(lang.services.electricchargingpoint.toLowerCase().replaceAll('&shy;', '\xAD'));
    if (facility.Services && facility.Services.includes('disabled')) services.push(lang.services.disabled.toLowerCase().replaceAll('&shy;', '\xAD'));
    if (facility.HasStp && !showDarkerTheme) services.push(lang.info.STP.toLowerCase().replaceAll('&shy;', '\xAD'));
    if (facility.HasLtp && !showDarkerTheme) services.push(lang.info.LTP.toLowerCase().replaceAll('&shy;', '\xAD'));
    if (facility.HasStp && showDarkerTheme) services.push(lang.info.STP_alt.toLowerCase());
    if (facility.HasLtp && showDarkerTheme) services.push(lang.info.LTP_alt.toLowerCase());
    if (services.length) {
      services[services.length - 1] += '.';
      services[0] = services[0].charAt(0).toUpperCase() + services[0].slice(1);
    }
    setServicesList(services.join(', '));
  }, [])

  const showOnMap = (e) => {
    e.preventDefault();
    const facilityUid = listItemRef.current.getAttribute('data-facility-uid');
    const selectedFacility = facilitySearchContext.allFacilities.find(f => f.Uid === facilityUid);
    setFacilitySearchContext({ ...facilitySearchContext, showOnMap: selectedFacility });
  }

  useEffect(() => {
    const mainContent = document.querySelector('.facilitysearchpage')
    setSTP(facilitySearchContext.filterSelection.STP);
    if (facilitySearchContext.filterSelection.STP) mainContent.classList.add('STP');
    else mainContent.classList.remove('STP');
  }, [facilitySearchContext.filterSelection])

  return (
    <li className={listItemClass} ref={listItemRef} data-facility-uid={uid}>
      <section className="left">
        <div className="top">
          {hasAvailableSpot && (!advSearch || !STP) ? <div className="left--availablespot" data-low={hasLowAvailability}><div><a href={url} onClick={(e) => { if (!url) e.preventDefault() }}>{facilityName}</a></div>
            <div>{hasLowAvailability ? lang.lowavailability : lang.availability}</div></div> :
            <a href={url} onClick={(e) => { if (!url) e.preventDefault() }}>{facilityName}</a>}
          {!advSearch && !STP && hasPromotion && <img src={`/publicResources/icons/promo/${selectedLanguage}/Promotion2_${selectedLanguage}.svg`}  alt="promotion icon" />}
        </div>
        <div className="distance">{currectDistance} {currectDistanceText} {lang.from} {location}</div>
        <div className="showonmap">{facilityAddress}<button onClick={showOnMap}>{lang.showonmap}</button></div>
        {advSearch && servicesList.length > 0 && <div className="services">{servicesList}</div>}
      </section>
      {advSearch && showPriceSuggestionBox && !STP && <section className="right" data-controller={facilityInfo.HasWaitingListUrl !== 'null' ? "myaimopark-confirm" : ""} data-confirm-label-text={lang.confirmlabel} data-confirm-close-text={lang.close} data-confirm-cancel-text={lang.cancel} data-confirm-confirm-text={lang.continue} data-confirm-heading-text={lang.notes}>
        {!pending && recommendedProduct && recommendedProduct.Promotions && !STP && <img className="facilitysearchpage__listitem--promo" src={`/publicResources/icons/promo/${selectedLanguage}/Promotion1_${selectedLanguage}.svg`}  alt="promotion icon" />}
        <div className={recommendedProduct === null ? 'recommendedprice loading' : 'recommendedprice'}>
          {pending ? <div className="aimo-spinner"><span></span><span></span><span></span><span></span></div> :
            recommendedProduct ? (<>
              <div>
                {lang.priceex}
                <span>{recommendedProduct.MonthlyPrice ?? 0} {recommendedProduct.Currency}/{lang.month}</span>
                <span>{recommendedProduct.OverviewText}</span>
                {!recommendedProduct.Availability && recommendedProduct.AvailableFrom && <span className="start-date">{lang.availablefrom} {parseDate(recommendedProduct.AvailableFrom, currentLocale, 'L')}</span>}
              </div>
              {(!recommendedProduct.AvailableFrom && facilityInfo.HasWaitingList && facilityInfo.WaitingListUrl !== 'null' ) ?
                <a href={url} onClick={(e) => { if (!url) e.preventDefault() }} className="facilitysearchpage__listitem__cta facilitysearchpage__listitem__cta--list" data-ltp-booking="interestlist" data-confirm="facility" data-confirm-message-text={facilityInfo.FilteredNotes}>{lang.waitinglist}</a>
                : (recommendedProduct.Availability == 0 && !recommendedProduct.AvailableFrom) ?
                <a href={url} onClick={(e) => { if (!url) e.preventDefault() }} className="facilitysearchpage__listitem__cta facilitysearchpage__listitem__cta--list facilitysearchpage__listitem__cta--red" data-ltp-booking="interestlist" data-confirm="facility" data-confirm-message-text={facilityInfo.FilteredNotes}>{lang.full}</a>
                :  (recommendedProduct.OnlineBookingNotAllowed) ?
                <a href={url} onClick={(e) => { if (!url) e.preventDefault() }} className="facilitysearchpage__listitem__cta facilitysearchpage__listitem__cta--list facilitysearchpage__listitem__cta--shorter" data-ltp-booking="interestlist" data-confirm="facility" data-confirm-message-text={facilityInfo.FilteredNotes}>Anm&#228;l intresse</a>
                : <a href={lang.bookingflowUrl + "?fId=" + uid + "&t=1"} className="facilitysearchpage__listitem__cta" data-ltp-booking="ltponline">{lang.book}</a>}
            </>) : <><div>{(facility.HasStp && !facility.HasLtp) ? "Only STP" : (!facility.HasStp && !facility.HasLtp) ? "No STP or LTP" : ""}</div><a href={lang.bookingflowUrl + "?fId=" + uid + "&t=1"}  className="facilitysearchpage__listitem__cta" data-ltp-booking="ltponline">{lang.book}</a></>
          }
        </div>
      </section>}
      {advSearch && !STP && <button className="showmore" disabled={!expanded && (recommendedProduct === null || Object.keys(facilityInfo).length === 0 || pending)} onClick={expandHandler} aria-expanded={expanded}><span>{expanded ? lang.showless : showDarkerTheme ? lang.showmoreinfoforltp : lang.showmoreinfo}</span></button>}
      {advSearch && STP && <button className="showmore" disabled={!expanded && (Object.keys(facilityInfo).length === 0 || pending)} onClick={expandHandler} aria-expanded={expanded}><span>{expanded ? lang.showless : lang.showmoreinfo}</span></button>}
      {advSearch && <ExpandableListItem STP={STP} campaignsPending={pending} facilitySearchContext={facilitySearchContext} uid={uid} date={date} expanded={expanded} products={productSelectionOptions} facilityInfo={facilityInfo} filteredNotes={filteredNotes} notesForZones={notesForZones} availabilityChangeHandler={availabilityChangeHandler} />}
    </li>
  )
}

export default ListItem;
